<!-- <nz-divider [nzDashed]="dividerDashed" [nzType]="dividerType" [nzText]="dividerText" [nzPlain]="dividerPlain" [nzOrientation]="dividerTextOrientation"></nz-divider> -->
<span class="ant-divider-inner-text" *ngIf="nzText">
  <ng-container *nzStringTemplateOutlet="nzText">{{ nzText }}</ng-container>
</span>
